import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export function PageHero({ kicker, eyebrow, title, text, image, crumbs = [], children, compact = false }) {
  const k = kicker || eyebrow;
  return (
    <section className="bg-white border-b border-gray-200" data-testid="page-hero">
      <div className={"sv-wrap grid gap-10 " + (image ? 'lg:grid-cols-12 items-center ' : '') + (compact ? 'py-10 md:py-12' : 'py-14 md:py-20')}>
        <div className={image ? 'lg:col-span-7' : 'max-w-[820px]'}>
          {crumbs.length > 0 && (
            <nav className="flex items-center gap-1.5 text-[13px] text-gray-600 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-ink">Home</Link>
              {crumbs.map(function (c, i) {
                return (
                  <React.Fragment key={i}>
                    <ChevronRight className="h-3.5 w-3.5" strokeWidth={1.75} />
                    {c.href ? <Link to={c.href} className="hover:text-ink">{c.label}</Link> : <span className="text-ink">{c.label}</span>}
                  </React.Fragment>
                );
              })}
            </nav>
          )}
          {k && <p className="sv-kicker">{k}</p>}
          <h1 className={"sv-display mt-2 " + (compact ? 'text-[36px] md:text-[40px]' : 'text-[40px] md:text-[56px]')}>{title}</h1>
          {text && <p className="text-lg text-gray-700 mt-5 max-w-[640px]">{text}</p>}
          {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
        </div>
        {image && (
          <div className="lg:col-span-5 h-[260px] md:h-[340px] rounded overflow-hidden bg-gray-200">
            <img src={image} alt="" className="w-full h-full object-cover" />
          </div>
        )}
      </div>
    </section>
  );
}

export function SectionHeading({ kicker, eyebrow, title, text, light = false }) {
  const k = kicker || eyebrow;
  return (
    <div className="max-w-[720px] mb-10 md:mb-12">
      {k && <p className={"text-sm " + (light ? 'text-white/70' : 'text-gray-600')}>{k}</p>}
      <h2 className={"text-[32px] md:text-[40px] sv-display mt-2 " + (light ? 'text-white' : '')}>{title}</h2>
      {text && <p className={"text-lg mt-4 " + (light ? 'text-white/70' : 'text-gray-700')}>{text}</p>}
    </div>
  );
}
